import _defineProperty from '@babel/runtime/helpers/defineProperty';
import Link from './Link.js';
import Icon from '../Icon/Icon.js';
import { jsx } from 'react/jsx-runtime';
import { USER_INTERFACE_ARROW_04_RIGHT } from '../IconPath/USER_INTERFACE_ARROW_04_RIGHT.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var ArrowLink = function ArrowLink(props) {
  var children = props.children;
  return /*#__PURE__*/jsx(Link, _objectSpread(_objectSpread({}, props), {}, {
    icon: /*#__PURE__*/jsx(Icon, {
      path: USER_INTERFACE_ARROW_04_RIGHT,
      size: "xxs"
    }),
    children: children
  }));
};

ArrowLink.defaultProps = {
  className: null,
  children: null,
  href: null,
  onClick: null
};
var ArrowLink$1 = ArrowLink;

export { ArrowLink$1 as default };
//# sourceMappingURL=ArrowLink.js.map
